import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { Ii18nState } from "./types";

export { createLoadLocalizationKeysAction } from "./actions";
export { DEFAULT_FETCHING_KEY, UNKNOWN_KEY_TEXT } from "./constants";
export { loadLocalizationIfNeeded } from "./externalUtils";
export {
    createGetLocalizedOptions,
    createGetPrimaryText,
    createGetSecondaryText,
    createGetTextCompareFn,
    getLocaleCode,
    getLocalizationItem,
    getPrimaryText,
    getSecondaryText,
    hasLocalization,
} from "./selectors";
export { ExtendedLocalizableOption, LocalizableOption, LocalizationItem } from "./types";
export { createAreLocalizationKeysLoadedActionPattern } from "./utils";

export const i18nModule: ApplicationStatefulModule<typeof NAME, Reducer<Ii18nState>> = {
    NAME,
    reducer,
    saga,
};
